import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';

type StyledBurgerProps = {
  open: boolean;
};

const StyledBurger = styled.button<StyledBurgerProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 18px;
  height: 18px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:focus {
    outline: none;
  }

  div {
    width: 100%;
    height: 2px;
    background: ${theme.colors.primary.graysGray};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 96%;

    :first-child {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }
  }
`;

export type HamburgerButtonProps = {
  isOpen: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

export const HamburgerButton = forwardRef<
  HTMLButtonElement,
  HamburgerButtonProps
>(({ isOpen, onClick, className }, ref) => {
  return (
    <StyledBurger
      ref={ref}
      className={className}
      open={isOpen}
      onClick={onClick}
    >
      <div />
      <div />
      <div />
    </StyledBurger>
  );
});
